import { FUND } from "../actions/types";
import axios from "axios";
import { toast } from "react-toastify";
import history from "../../helpers/history";
import { logout } from "../actions/Auth";
import { call, put, takeLatest } from "redux-saga/effects";
import { authHeader } from "../../lib/authHeader";
import { loadingFinish } from "../actions/Loading";
import {
  fundUssdSuccess,
  fetchCardSuccess,
  fetchWalletHistorySuccess,
} from "../actions/Fund";

import { updateProfile } from "../actions/Settings";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}agent`;
const headers = authHeader();

function* handleUssdFund({ payload }) {
  const apiUrl = `${API_BASE}/wallet/topup/ussd`;
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiCall = async () => {
    const data = {
      ...payload.payload,
      token,
    };
    try {
      const result = await axios.post(apiUrl, data, { headers });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      const code = result.data.data;
      let ussd;
      code.forEach((element) => {
        if (element.bank_name === payload.bankName)
          ussd = element.bank_ussd_code;
      });

      yield put(fundUssdSuccess(ussd));
      toast.success("Code generated successfully");
    } else {
      toast.error(result.data.message);
      throw result.data.message;
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleFetchCards({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/card/list?user_id=${payload}`;

  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success" && result.data.data) {
      yield put(fetchCardSuccess(result.data.data));
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleCardFund({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/wallet/topup/card`;

  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(updateProfile());
      sessionStorage.setItem("message", result.data.message);
      history.push("/agent/fund");
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleCreateCard({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/card/create`;

  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "error") {
      toast.error(result.data.message);
    } else {
      toast.success(result.data.message);
    }
    history.push("/agent/fund/card");
  } catch (error) {
    throw error;
  } finally {
    yield put(loadingFinish());
  }
}

function* handleFetchWalletHistory({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/wallet/history/list`;

  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...payload,
        },
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "error") {
      // toast.error(result.data.message);
    } else if (result.data.message) {
      yield put(fetchWalletHistorySuccess(result.data.message));
    } else {
      // toast.success(result.data.data);
      yield put(fetchWalletHistorySuccess(result.data.data));
    }
  } catch (err) {
    let error = err;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

const fundSaga = [
  takeLatest(FUND.FUND_USSD, handleUssdFund),
  takeLatest(FUND.FUND_CARD, handleCardFund),
  takeLatest(FUND.FETCH_CARDS, handleFetchCards),
  takeLatest(FUND.CREATE_CARD, handleCreateCard),
  takeLatest(FUND.WALLET_HISTORY, handleFetchWalletHistory),
];

export default fundSaga;
